<template>
  <div class="coredata-form">
    <div v-for="(field, i) in formFields" :key="i">
      <!-- <pre>{{ field }}</pre> -->
      <DataInput
        v-if="field.type === 'model'"
        :value="getModelValue(field)"
        v-bind="field"
        @input="val => setModelValue(field.name, val)"
      />
      <DataInput
        v-else-if="field.type === 'html'"
        :value="getModelValue(field)"
        v-bind="field"
        @input="val => setModelValue(field.name, val)"
      />
      <DataInput v-else v-model="value[field.name]" v-bind="field" />
    </div>
    <div class="con-btns-coredata">
      <div class="flex">
        <vs-button
          vs-type="gradient"
          color="success"
          icon-pack="fas"
          icon="fa-save"
          @click="submit"
          >{{ entryIndex === null ? "Erstellen" : "Speichern" }}</vs-button
        >
        <vs-button
          v-if="entryIndex !== null"
          class="ml-2"
          vs-type="flat"
          color="danger"
          icon-pack="fas"
          icon="fa-trash"
          @click="deleteEntry"
        ></vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  props: {
    formFields: { type: Array, required: true },
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    entryIndex: { type: Number, default: null }
  },
  data() {
    return {
      mergeValueFields: {},
      toolbarOptions: [
        [{ size: ["small", false, "large", "huge"] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        ["bold", "italic", "underline", "strike"], // toggled buttons

        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ align: [] }],

        ["clean"] // remove formatting button
      ]
    };
  },
  methods: {
    submit() {
      this.$emit("submit", {
        index: this.entryIndex,
        data: Object.fromEntries(
          Object.entries(
            Object.assign(this.value, this.mergeValueFields)
          ).filter(
            ([key]) =>
              key === "id" ||
              this.formFields.find(f => f.name.split("{")[0] === key)
          )
        )
      });
    },
    deleteEntry() {
      this.$emit("delete", {
        index: this.entryIndex,
        data: this.value
      });
    },
    getModelValue(field) {
      //console.log(fieldName.split("{"), this.value, this.value[fieldName.split("{")[0]])
      return this.value[field.name.split("{")[0]];
    },
    setModelValue(fieldName, val) {
      this.mergeValueFields = {
        ...this.mergeValueFields,
        ...{ [fieldName.split("{")[0]]: val }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.con-btns-coredata {
  display: flex;
  padding: 10px 0;
  align-items: center;
  justify-content: flex-end;
}
</style>
